import Model, { ModelErrors } from "./Model";

export interface UploadedFileData {
  id: number;

  original_name: string;

  reference: string;

  extension: string;

  file_type: string;

  date_uploaded: string;

  user_id: number;

  is_complete: boolean;

  used_for: string;

  used_for_id: number;

  [propName: string]: string | boolean | number;
}

function isBool(n: any): n is boolean {
  return typeof n === 'boolean';
}

export default class UploadedFileModel extends Model<Partial<UploadedFileData>> {
  progress = 0;

  currentChunk = -1;

  previousChunk = -1;

  isInProgress(): boolean {
    return [0, -1, 100].indexOf(this.progress) === -1;
  }

  isEditable(): boolean {
    if (this.data.used_for) {
      return this.data.used_for.length === 0
        && ((isBool(this.data.is_complete) && this.data.is_complete)
          || (this.progress === 100));
    }

    return true;
  }

  isRetrying(): boolean {
    return this.currentChunk > -1 && this.currentChunk === this.previousChunk;
  }
}

export function create(data?: Partial<UploadedFileData>, errors?: ModelErrors): UploadedFileModel {
  return new UploadedFileModel(data, errors);
}
